import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, input, viewChildren } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatSidenav } from '@angular/material/sidenav';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { LocaleService } from '@zhik/core/services/locale';
import { PlatformDataService } from '@zhik/core/services/platform-data';
import { DskHomeUserStore } from '@zhik/core/store/dskhome-user';
import { MortgageApplicationStore } from '@zhik/core/store/mortgage-journey/mortgage-application';

@Component({
  selector: 'dskhome-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  imports: [
    RouterLink,
    RouterLinkActive,
    MatButtonModule,
    MatIcon, MatMenu,
    MatMenuItem,
    MatDivider,
    MatMenuTrigger,
    NgOptimizedImage
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuComponent {
  protected readonly dskHomeUserStore = inject(DskHomeUserStore);
  private readonly localeService = inject(LocaleService);
  private readonly platformDataService = inject(PlatformDataService);
  private readonly mortgageApplicationStore = inject(MortgageApplicationStore);
  private readonly destroyRef = inject(DestroyRef);

  matMenus = viewChildren(MatMenuTrigger);

  readonly localeId = this.localeService.localeId;
  readonly nextLanguageCode = this.localeService.getNextLanguageCode();
  readonly isMortgageApplicationPath = this.mortgageApplicationStore.isMortgageApplicationPath;
  readonly otpFlagSvgName = `otp-flag-${this.nextLanguageCode}`;

  isPurchaseSubmenuRouteActive = input.required<boolean>();
  snav = input.required<MatSidenav>();

  constructor() {
    if (this.platformDataService.isBrowser) {
      toObservable(this.platformDataService.windowWidthChange).pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe(() => {
        this.matMenus()?.forEach(menu => {
          if (menu.menuOpen) {
            menu.closeMenu();
          }
        });
      });
    }
  }

  // TODO: handle logout error (not successfully logout)
  logout(): void {
    this.dskHomeUserStore.logoutUser();
  }

  removeFocus(htmlEl: HTMLAnchorElement): void {
    htmlEl.blur();
  }

  toggleLocale(): void {
    this.localeService.toggleLocale();
  }
}
